import axios from "@/plugins/axios";

import admins from "./admins";
import cashes from "./cashes";
import levels from "./levels";
import logs from "./logs";
import members from "./members";
import messages from "./messages";
import partners from "./partners";
import cps from "./cps";
import setting from "./setting";
import shop from "./shop";
import terms from "./terms";
import users from "./users";
import common from "./common"
import dashboard from "./dashboard";

import * as platforms from "./platforms";

export default {
    admins,
    cashes,
    levels,
    logs,
    members,
    messages,
    partners,
    cps,
    setting,
    shop,
    terms,
    users,
    common,
    dashboard,
    ...platforms,
    
    email: {
        post({ to, subject, html }){
            return axios.post("/api/console/email", { to, subject, html }).then(result => result.data);
        }
    },
    message: {
        post({ to, subject, message }){
            return axios.post("/api/console/message", { to, subject, message }).then(result => result.data);
        }
    }
};